<mat-card class="border-radius-0 box-shadow" *ngIf="connectionStatus$ | async">
  <app-data-box headerTitle="Find Flight/Sequence" class="search-box">
    <div class="search-container">
      <div class="text-sm opacity-6 p-8">
        View flights or sequences that are not part of your schedule (commute or
        other flights of interest).
      </div>
      <mat-tab-group>
        <mat-tab label="Route">
          <form
            [formGroup]="routeForm"
            (ngSubmit)="onRouteSubmit()"
            class="form-container"
          >
            <div class="from-to">
              <mat-form-field appearance="outline" class="arpt-input">
                <mat-label>From</mat-label>
                <input
                  matInput
                  formControlName="from"
                  [maxlength]="3"
                  (input)="capitalize(routeForm.controls.from)"
                />
              </mat-form-field>
              <mat-icon
                mat-ripple
                class="pointer swap-icon"
                (click)="onSwapClick()"
                >swap_horiz</mat-icon
              >
              <mat-form-field appearance="outline" class="arpt-input">
                <mat-label>To</mat-label>
                <input
                  matInput
                  formControlName="to"
                  [maxlength]="3"
                  (input)="capitalize(routeForm.controls.to)"
                />
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>Date</mat-label>
              <input
                matInput
                [matDatepicker]="routePicker"
                (click)="routePicker.open()"
                formControlName="date"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="routePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #routePicker></mat-datepicker>
            </mat-form-field>
            <button
              type="submit"
              mat-stroked-button
              [disableRipple]="true"
              color="primary"
              [disabled]="routeForm.invalid"
            >
              Search
            </button>
          </form>

          <!-- Search results -->
          <app-data-box
            *ngIf="routeSearch$ | async as flightList"
            headerTitle="Flight Results"
            class="results-box"
            [topBorderOnly]="true"
          >
            <div *ngIf="flightList.isLoading" class="flex-center p-16">
              <mat-spinner color="accent" [diameter]="32"></mat-spinner>
            </div>
            <div
              *ngIf="!flightList.isLoading && flightList.response"
              class="flex-center flight-list-container"
            >
              <div
                *ngIf="flightList.response.flights.length === 0"
                class="text-base font-medium"
              >
                No flights found
              </div>
              <div
                *ngIf="flightList.response.flights.length > 0"
                class="text-center text-xs opacity-6 font-light mb-16"
              >
                <p>
                  Pinned flights are displayed below the calendar for quick
                  access.
                </p>
              </div>
              <div
                *ngFor="let flight of flightList.response.flights"
                class="flight-list-row"
              >
                <div
                  mat-ripple
                  class="flight-list box-shadow thin-blue-border"
                  (click)="onFlightClicked(flightList.response, flight)"
                  [class.departed]="flight.status === 'departed'"
                >
                  <div class="flt-row accent-color">
                    <div
                      class="text-base font-medium"
                      [class.warn-color]="flight.status === 'canceled'"
                    >
                      AA {{ flight.flightNumber }}
                    </div>
                  </div>
                  <div class="flt-row">
                    <div class="flt-col">
                      <div class="text-sm font-light accent-color">
                        {{ flightList.response.depStation }}
                      </div>
                      <div
                        class="text-base font-medium"
                        [class.warn-color]="
                          flight.status === 'delayed' ||
                          flight.status === 'canceled'
                        "
                        [class.cxld-time]="flight.status === 'canceled'"
                      >
                        {{ flight.departureTime | time }}
                      </div>
                    </div>
                    <div class="flex-center text-sm font-light acft">
                      - {{ flight.equipment }} -
                    </div>
                    <div class="flt-col">
                      <div class="text-sm font-light accent-color">
                        {{ flightList.response.arrStation }}
                      </div>
                      <div
                        class="text-base font-medium"
                        [class.warn-color]="
                          flight.status === 'delayed' ||
                          flight.status === 'canceled'
                        "
                        [class.cxld-time]="flight.status === 'canceled'"
                      >
                        {{ flight.arrivalTime | time }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pin-container primary-color">
                  <mat-icon
                    class="pin-icon"
                    fontSet="material-icons-outlined"
                    matRipple
                    *ngIf="!flight.isSaved"
                    (click)="
                      onStarClick(flight.id, flightList.response, flight)
                    "
                    >push_pin</mat-icon
                  >
                  <mat-icon
                    class="pin-icon"
                    mat-ripple
                    *ngIf="flight.isSaved"
                    (click)="
                      onStarClick(flight.id, flightList.response, flight)
                    "
                    >push_pin</mat-icon
                  >
                </div>
              </div>
            </div>
          </app-data-box>
        </mat-tab>

        <mat-tab label="Seq #">
          <form [formGroup]="seqForm" (ngSubmit)="onSeqSubmit()">
            <div class="seq-form-container">
              <mat-form-field appearance="outline" class="text-input">
                <mat-label>Sequence #</mat-label>
                <input
                  matInput
                  [minLength]="3"
                  [maxLength]="5"
                  formControlName="seqNum"
                  (input)="numeric(this.seqForm.controls.seqNum)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="text-input">
                <mat-label>Position</mat-label>
                <select matNativeControl required formControlName="position">
                  <option value="CA" selected>CA</option>
                  <option value="FO">FO</option>
                  <option value="FB">FB</option>
                  <option value="FC">FC</option>
                  <option value="RC">RC</option>
                </select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="text-input">
                <mat-label>Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="seqPicker"
                  (click)="seqPicker.open()"
                  formControlName="date"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="seqPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #seqPicker></mat-datepicker>
              </mat-form-field>
              <button
                type="submit"
                mat-stroked-button
                color="primary"
                [disabled]="seqForm.invalid"
              >
                Search
              </button>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </div>
  </app-data-box>
</mat-card>
